module.exports = __webpack_public_path__ + "img/LSI_MapBackgrounds_400x400.webp";